import en from './en';
import de from './de';
import fr from './fr';
import es from './es';

const translations = {
  en,
  de,
  fr,
  es,
  // ...add other languages...
};

export default translations;